//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from "vuex";
export default {
  name: "AuthBottom",
  data() {
    return {
      telegram_credential: window.telegram_credential,
    };
  },
  methods: {
    ...mapMutations(["SET_LOGIN_HIDE"]),
    goHome() {
      // 去首页
      this.SET_LOGIN_HIDE();
      this.$router.replace({ path: "/" });
    },
  },
};



// WEBPACK FOOTER //
// ./src/pages/build800/components/AuthBottom.vue